// extracted by mini-css-extract-plugin
export default {"detailContainer":"detailContainer-XZ4sr","detailContainerInner":"detailContainerInner-PceCr","testName":"testName-Xi_5u","flexRow":"flexRow-G8BOe","testsRow":"testsRow-TurNz"};